import {
		GET_CATEGORY_CMS_CONTENT,
		GET_PRODUCTS_BY_SKUS,
		GET_DEALS_PRODUCTS_BY_SKUS,
		GET_CURRENCY_SYMBOL
} from '../actionTypes/index';

const initialState = {
		products: {},
		categoryCmsContent: null,
		currencySymbol: ''
};

export default (state = initialState, { type, payload }) => {
		switch (type) {
				case GET_CATEGORY_CMS_CONTENT:
						return {
								...state,
									categoryCmsContent: {
											...state.categoryCmsContent,
											[payload.categoryId]: {
													...payload
											}
									}
						};
				case GET_PRODUCTS_BY_SKUS:
						return {
								...state,
								products: {
										...state.products,
										[payload.id]: payload
								}
						};
				case GET_DEALS_PRODUCTS_BY_SKUS:
						return {
								...state,
								products: {
										...state.products,
										[payload.id]: payload
								}
						};
				case GET_CURRENCY_SYMBOL:
						return {
								...state,
								currencySymbol: payload.currencySymbol,
						};
				default:
						return state;
		}
};
